import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logoImg from '../assets/blast-logo.webp';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3301/api';

export default function AllMembers() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/member-auth/public`)
      .then((res) => setMembers(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} />
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>
      </nav>
      <div style={{ padding: '0 6vw 60px', maxWidth: 1000, margin: '0 auto' }}>
        <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          Roster
        </span>
        <h1 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 30px' }}>
          Semua Member
        </h1>
        {loading ? (
          <p style={{ color: '#8B92A0' }}>Memuat...</p>
        ) : members.length === 0 ? (
          <p style={{ color: '#8B92A0' }}>Belum ada member.</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 32 }}>
            {members.map((m) => (
              <Link
                key={m.id}
                to={`/members/${m.slug}`}
                style={{
                  background: '#1C2128', border: '1px solid #262b33', padding: 20,
                  clipPath: 'polygon(0 0, 100% 0, 100% 92%, 92% 100%, 0 100%)',
                  textDecoration: 'none', color: 'inherit', display: 'block',
                }}
              >
                <div style={{
                  width: '100%', aspectRatio: '4/5', background: '#262b33', marginBottom: 14,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4a5160', fontSize: 12,
                  overflow: 'hidden',
                }}>
                  {m.photo_url ? (
                    <img src={m.photo_url} alt={m.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : 'Foto Member'}
                </div>
                {m.quote && <p style={{ color: '#c8ccd3', fontSize: 12, fontStyle: 'italic', marginBottom: 6 }}>"{m.quote}"</p>}
                <p style={{ fontWeight: 800, fontSize: 16 }}>{m.name}</p>
                <p style={{ color: '#D02127', fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase' }}>{m.position}</p>
                <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>{m.motor_type || '-'}</p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
